// ============================================================
// Hirafi — Module devis : génération d'URLs publiques
//
// Toutes les URLs sont basées sur le domaine principal hirafidz.com.
// Toutes les URLs sont basées sur le domaine principal uniquement.
// ============================================================

const BASE_URL =
  typeof window !== "undefined"
    ? window.location.origin
    : "https://www.hirafidz.com";

/** URL publique d'un devis partageable par token */
export function getPublicDevisUrl(publicToken: string): string {
  return `${BASE_URL}/q/${publicToken}`;
}

/** Message WhatsApp pré-rempli avec le lien du devis */
export function getWhatsappShareUrl(publicToken: string, clientPhone?: string): string {
  const url = getPublicDevisUrl(publicToken);
  const text = encodeURIComponent(`Bonjour, voici votre devis Hirafi : ${url}`);
  const phone = clientPhone ? clientPhone.replace(/\D/g, "") : "";
  return `https://wa.me/${phone}?text=${text}`;
}

/** Mailto pré-rempli pour envoi du devis (SEC-008 : strip newlines pour éviter header injection) */
export function getEmailShareUrl(
  publicToken: string,
  clientEmail: string,
  title: string
): string {
  // Supprimer les caractères de contrôle qui permettraient une injection d'en-têtes mailto
  const safeEmail = clientEmail.replace(/[\r\n\t]/g, "");
  const url = getPublicDevisUrl(publicToken);
  const subject = encodeURIComponent(`Votre devis : ${title}`);
  const body = encodeURIComponent(
    `Bonjour,\n\nVeuillez trouver ci-dessous le lien vers votre devis :\n${url}\n\nCordialement,\nHirafi`
  );
  return `mailto:${safeEmail}?subject=${subject}&body=${body}`;
}
